import type { AppLocale } from "./locales";
import { DEFAULT_LOCALE } from "./locales";

function titleCaseWords(value: string): string {
  return value
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

/** Translate a region/prefecture display name; falls back to the English key. */
export function regionLabel(
  t: (key: string, options?: { defaultValue?: string }) => string,
  prefecture: string,
): string {
  const candidates = [prefecture, titleCaseWords(prefecture)];
  for (const candidate of candidates) {
    const translated = t(`regions.${candidate}`, {
      defaultValue: "__MISSING__",
    });
    if (translated !== "__MISSING__") return translated;
  }
  return titleCaseWords(prefecture) || prefecture;
}

export function isDefaultLocale(locale: AppLocale): boolean {
  return locale === DEFAULT_LOCALE;
}
